// extracted by mini-css-extract-plugin
export var gridImgTextContainer = "modal-module--gridImgTextContainer--ligTC";
export var modalWrapper = "modal-module--modalWrapper--6ys8c";